import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import PowderCoatingOne from "../images/Powder Coating/powdercoatedone.jpg";
import AktVideo from "./Akt-Powder-Video"
import PowderCoatedPicThree from "../images/Powder Coating/AUTO-POWDER-COATING-PIC-3.jpg";
import PowderCoatedPicFour from "../images/Powder Coating/AUTO-POWDER-COATING-PIC-4.jpg";
import PowderCoatedPicOne from "../images/Powder Coating/AUTO POWDER COATING PIC 1.png";
import PowderCoatedPicSix from "../images/Powder Coating/AUTO-POWDER-COATING-PIC-6.jpg";
import PowderCoatedPicFive from "../images/Powder Coating/AUTO-POWDER-COATING-PIC-5.jpg";
import PowderCoatedPicTwo from "../images/Powder Coating/AUTO-POWDER-COATING-PIC-2.jpg";
import "../components/Section/car.css";

function AktPowdercoating() {
  const [showAnimation, setShowAnimation] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowAnimation(false);
    }, 2000); // 3 seconds delay

    return () => clearTimeout(timer);
  }, []);


  return (

    <div className="bg-[#0C2341]  min-h-screen mt-2">
      {showAnimation ? (
        // Spinning Circle Animation
        <div className="flex justify-center items-center min-h-[50vh]">
          <motion.div
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 1, ease: "easeInOut" }}
            className="w-16 h-16 border-4 border-t-blue-500 border-b-transparent border-r-transparent border-l-blue-500 rounded-full"
          ></motion.div>
        </div>
      ) : (
        <main className="w-full">
          <div className="w-full overflow-hidden font-sans text-gray-800 !bg-[#ffffff]">
            <section className="relative w-full h-[70vh]">
              <img src={PowderCoatingOne} alt="Hero" className="absolute inset-0 w-full h-full object-cover" />

              <div className="absolute bottom-0 left-0 right-0 flex justify-center pb-6">
                <div className="px-6 py-4 text-center rounded-md max-w-3xl pt-3 mx-auto">
                  <h2
                    className="text-3xl sm:text-4xl font-bold tracking-widest "
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    OUR SERVICES
                  </h2>
                  <p className="text-lg sm:text-xl text-gray-800 leading-relaxed">
                    We offer a wide range of services from paint protection film and window
                    film installation to detailing and storage. Our experts know how to
                    keep your vehicle looking flawless.
                  </p>
                </div>
              </div>
            </section>


            {/* Description */}


            {/* Sections */}
            <div className="space-y-12">
              {/* Section 1 */}
              <div className='text-center mt-4 max-w-3xl mx-auto'>
                <h2
                  className="text-3xl font-bold tracking-widest"
                  style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                >
                  POWDER COATING SERVICES
                </h2>
              </div>
              <div className="md:flex items-center justify-center">
                <img src={PowderCoatedPicOne} alt="Preparation" className="md:w-1/2 w-full rounded-lg h-[650px]" />
                <div className="w-full p-4 bg-white shadow-lg text-center justify-center md:w-[45%]">
                  <h2
                    className="text-2xl font-bold tracking-widest p-8"
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    POWDER COATING PROCESS
                  </h2>
                  <p className="text-gray-800 text-xl leading-normal pb-4 text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>
                    Powder coating is a durable, high-quality finish applied to car wheels and parts for protection and enhanced appearance. The process involves cleaning and prepping the surface, then applying a charged powder using an electrostatic spray gun. The powder sticks to the metal and is cured in a high-temperature oven, forming a tough, protective layer. It’s highly resistant to chips, scratches, fading, and corrosion. With various color and texture options, powder coating offers a long-lasting, stylish finish that keeps vehicle parts looking and performing like new.
                  </p>
                </div>
              </div>

              {/* Section 2 */}
              <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
                <img src={PowderCoatedPicTwo} alt="Non-invasive" className="md:w-1/2 w-full rounded-lg" />
                <div className="w-full p-4 bg-white shadow-lg text-center justify-center md:w-[45%]">

                  <h2
                    className="text-2xl font-bold tracking-widest p-4"
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    COLOR PROCESS
                  </h2>
                  <p className="text-gray-800 text-xl pb-4 leading-normal text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>
                    Choosing the right color for your vehicle parts is a key step in the powder coating process. We offer a variety of colors, finishes, and textures, from classic gloss black to bold metallics and custom shades. Our experts guide you to select the perfect color to match your car’s look or create a new style. Each powder coating is vibrant, durable, and fade-resistant for long-lasting beauty. We also offer special effects like candy colors, two-tone finishes, and textured coats for a customized appearance. Our premium-quality powders ensure a flawless coat with every application. Let us help you make your vehicle stand out with a color that speaks to your unique style.
                  </p>
                </div>
              </div>

              {/* Section 3 */}
              <div className="md:flex items-center justify-center px-4 py-4">
                <img src={PowderCoatedPicThree} alt="Durability" className="md:w-1/2 w-full rounded-lg" />
                <div className="w-full p-4 bg-white shadow-lg text-center justify-center md:w-[45%]">
                  <h2
                    className="text-2xl font-bold tracking-widest p-4"
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    CUSTOM COLORS SECTION
                  </h2>
                  <p className="text-gray-800 text-xl leading-normal pb-4 text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>

                    We offer custom color options to bring your vision to life. Whether you're looking for a unique shade, blend, or finish, we can create a custom powder coating for you. Our team works closely with you to understand your preferences, ensuring the final result matches your expectations. From vibrant neons to deep pearls and multi-stage effects, the possibilities are endless. Crafted with high-quality powders, our custom colors ensure durability and a flawless finish. Each project goes through careful matching and testing for consistency. Whether you want to match your car’s original paint or create something bold, we can make it happen. Stand out with a color that's uniquely yours.
                  </p>
                </div>
              </div>

              {/* Section 4 */}
              <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
                <img src={PowderCoatedPicFour} alt="Our Prep" className="md:w-1/2 w-full rounded-lg" />
                <div className="w-full p-4 bg-white shadow-lg text-center justify-center md:w-[45%]">

                  <h2
                    className="text-2xl font-bold tracking-widest p-4"
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    OUR PREP
                  </h2>
                  <p className="text-gray-800 text-xl leading-normal pb-4 text-justify" style={{ wordSpacing: '0', hyphens: 'auto' }}>
                    Proper preparation is the key to a flawless and long-lasting powder coating finish.
                    Our prep process begins with a detailed inspection of each part to identify any imperfections.
                    We then clean the surface thoroughly to remove dirt, grease, and old coatings.
                    Depending on the condition of the part, we use methods like sandblasting or chemical stripping to ensure a completely bare, smooth surface.
                    After cleaning, we carefully inspect again to make sure the part is ready for coating.
                    Any necessary repairs or smoothing are completed to achieve a perfect base. This meticulous preparation ensures the powder adheres evenly and the finish remains strong over time.
                    By focusing on every detail during the prep stage, we guarantee better durability, enhanced appearance, and a professional-quality result that stands out.
                    At our facility, we believe great prep work is the foundation of great powder coating.
                  </p>
                </div>
              </div>

              {/* Car Detailing */}
              <section className="relative w-full h-[80vh] p-4">
                <img src={PowderCoatedPicSix} alt="Hero" className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-y-0 right-0 flex items-center justify-end pr-10">
                  <div className="px-6 py-6 text-center rounded-md max-w-3xl text-white">
                    <h2
                      className="text-2xl sm:text-4xl font-bold tracking-widest mb-4"
                      style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                    >
                      CAR DETAILING
                    </h2>
                    <p className="text-lg sm:text-xl leading-relaxed">
                      At AKT, we offer professional car detailing services to keep your vehicle looking its absolute best. Our team carefully cleans, polishes, and protects every surface, inside and out. We use premium products and techniques to restore your car’s shine and freshness. Trust AKT to bring out the true beauty of your vehicle.
                    </p>
                  </div>
                </div>
              </section>
              <div className="md:flex md:flex-row-reverse items-center justify-center px-4 py-4">
                <img src={PowderCoatedPicFive} alt="Our Prep" className="md:w-1/2 w-full rounded-lg" />
                <div className="md:w-1/3 w-full p-8 bg-white shadow-lg text-center justify-center">
                  <h2
                    className="text-2xl font-bold tracking-widest p-8"
                    style={{ fontFamily: "'Eurostile', 'Orbitron', sans-serif" }}
                  >
                    BENEFITS
                  </h2>
                  <ul className="text-lg sm:text-xl text-gray-800 text-left">
                    <li>- Secure, gated buildings</li>
                    <li>- Temperature controlled, dust free</li>
                    <li>- 24/7 on-site security with CCTV monitoring</li>
                    <li>- Surgically clean environment</li>
                    <li>- Kuberth easy-rise tyre cradles</li>
                    <li>- CTEK battery maintainer / charger</li>
                    <li>- Supersoft black fitted car cover</li>
                    <li>- Deep wash upon entry</li>
                    <li>- Monthly washing & starting procedure</li>
                    <li>- Out of hours access available</li>
                    <li>- Dedicated parking spaces</li>
                  </ul>
                </div>
              </div>
            </div>
            {/* powder coating video section*/}
            <h1 className="text-2xl md:text-4xl  font-bold text-center">
              POWDER COATING PROCESS
            </h1>

            <AktVideo />
            {/* <div className="py-6">
            <div className="bg-white rounded-xl">
              <div className="mx-auto px-4 py-10 sm:px-10 sm:py-14">
                <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
                  {powderCoatingItems.map((item) => (
                    <div
                      key={item.id}
                      className="group block overflow-hidden rounded-2xl shadow-2xl hover:shadow-2xl transition-all duration-300 hover:scale-105 bg-gradient-to-br from-white to-gray-50 cursor-pointer"
                    >
                      <div className="relative">
                        <div className="w-full h-64 overflow-hidden">
                          <img
                            src={item.img}
                            alt={item.name}
                            className="w-full h-full object-cover transition-opacity duration-300 rounded-t-2xl"
                          />
                          {item.type === "video" && (
                            <div className="absolute inset-0 flex items-center justify-center">
                              <img
                                src={PlayButton}
                                alt="Play Button"
                                className="h-20 rounded-full bg-black/45 hover:bg-[#0c2340]"
                              />
                            </div>
                          )}
                        </div>
                        <div className="px-4 py-3 text-center">
                          <h3 className="text-lg sm:text-xl md:text-2xl font-semibold text-gray-800 group-hover:text-blue-600 transition duration-300 tracking-wide">
                            {item.name}
                          </h3>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div> */}
          </div >
        </main>
      )}
    </div>

  );
}

export default AktPowdercoating;